import React from 'react';
import styled from 'styled-components';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';

import Navigation from '../components/Navigation';
import FooterUI from '../components/ui/FooterUI';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: url('/images/grass-background.jpg');
  padding-bottom: 50px;
  position: relative;
`;

const MailChimp = styled.div`
  #mc_embed_signup {
    padding: 0;
  }

  #mc_embed_signup_scroll {
    position: relative;
    width: 330px;
    box-shadow: 0px 4px 10px rgba (0,0,0,1);

    transition: width 0.5s;

    &:focus-within {
      width: 360px;
    }
  }

  input.email {
    width: 100%;
    padding: 20px 60px 20px 20px;
    border-radius: 0px;
    border: none;
    font-weight: 500;
    box-shadow: 0px 6px 10px rgba(0,0,0,.1);
    border-radius: 2px;
  }

  input.button {
    position: absolute;
    padding: 20px 30px;
    top: 0px;
    right: -5px;
    border: none;
    background-color: #00AD83;
    font-size: 1em;
    font-weight: 700;
    color: white;
    border-radius: 2px;
    box-shadow: -3px 0px 3px rgba(0,0,0,.1);


    transition: right 0.5s;

    &:hover {
      right: 0px;
      filter: brightness(97%);
    }
  }

`;



const mailChimpSignupForm = `
  <div id="mc_embed_signup">
    <form action="https://faculty.us18.list-manage.com/subscribe/post?u=ba1f40349fe6cc294d757c0e9&amp;id=556b3768a6" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">
        <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Enter your email" required>
        <div style="position: absolute; left: -8000px;" aria-hidden="true"><input type="text" name="b_8a0e413fe2615c2bdca4c4aae_7e1e7014cf" tabindex="-1" value=""></div>
        <input type="submit" value="Send" name="subscribe" id="mc-embedded-subscribe" class="button">
      </div>
    </form>
  </div>
`;

const SVGWrapper = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0.2;
`;

const backgroundSVG = `
  <svg width="100%" viewBox="0 0 1440 1289" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="main-copy-8" fill="#37C9A5">
            <path d="M1440,565.759036 L1440,1263.08729 C1049.47413,872.58249 416.323723,872.588986 25.8059276,1263.10678 L0,1288.91271 L0,0 L644.461159,0 C657.362046,144.752974 719.211908,285.964805 830.010745,396.763642 C995.374464,562.127361 1228.48193,618.45916 1440,565.759038 Z" id="Combined-Shape"></path>
      </g>
    </g>
  </svg>
`;

const H2 = styled.h2`
  color: white;
  font-size: 3.4em;
  max-width: 690px;
  line-height: 1.2em;
  padding-top: 50px;
  font-weight: 700;
  position: relative;
`;

const H3 = styled.h3`
  color: white;
  font-size: 1.6em;
  text-align: center;
  font-weight: 600;
  padding: 100px 0px 20px;
`;

const H4 = styled.h4`
  text-align: center;
  font-size: 2.6em;
  color: white;
  line-height: 1.3em;
  padding: 0px 0 15px;
  font-weight: 700;
`;

const PrizeH4 = styled(H4)`
  margin-bottom: 0;
  padding-bottom: 0;
`;

const PrizeSpan = styled.span`
  display: block;
  text-align: center !important;
  font-size: 6em;
  color: white;
  opacity: 0.3;
  font-weight: 700;
`;

const Caption = styled.span`
  display: block;
  color: white;
  font-size: 1.2em;
  max-width: 460px;
  line-height: 1.8em;
  margin: 30px 0 40px;

`;

const SmCaption = styled.span`
  display: block;
  color: white;
  opacity: 0.6;
  font-size: .8em;
  line-height: 1em;
  margin: 15px 0px;
  font-weight: 500;
  text-align: center;
`;

const CardFan = styled.div`
    height: 356px;
    width: 100%;
    margin: 2rem auto 0;
    position: relative;

  img {
    position: absolute;
    left: 100px;
    top: 40px;
    width: 260px;
    height: 100%;
    box-shadow: 4px 4px 3px rgba(0, 0, 0, 0.2);
    transform-origin: center 400px;
    transition: all .35s linear;
  }
  :first-child {
    transform: rotate(5deg);
  }
  :last-child {
    transform: rotate(-5deg);
  }
  :hover img:first-child {
    transform: rotate(40deg) translateX(100px);
  }
  :hover img:last-child {
    transform: rotate(-15deg);
  }
  :hover img:last-child {
    transform: rotate(-20deg) translateX(-20px);
  }
  :hover img:nth-child(2) {
    transform: rotate(15deg) translateY(-60px);
  }
`;

const P = styled.p`
  color: white;
  font-size: 1.2em;
  line-height: 1.7em;
  text-align: center;
  margin: 0 auto;
`;

const Cta = styled.a`
  padding: 12px 0px;
  border: none;
  background-color: #00AD83;
  font-size: .8em;
  font-weight: 700;
  color: white;
  border-radius: 0px 0px 2px 2px;
  box-shadow: 0px 3px 3px rgba(0,0,0,.1);
  width: 100%;
  bottom: 0px;
  right: 0px;
  position: absolute;

  :hover, :active, :visited, :focus {
      text-decoration:none;
      color: white;
  }
`
const PrizeBlock = styled.div`
  text-align: center;
  color: #393939;
  font-size: 1.3em;
  border-radius: 50%;
  position: relative;
  height: 30px;
  width: 30px;
  vertical-align: middle;
  margin: 40px auto 70px;
  background: transparent;
  border-radius: 50%;
  color: #fff;
  animation: animate 5s linear infinite;

  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: -35px;
    top: -15px;
  }

  @keyframes animate
  {
  	0%
  	{box-shadow: 0 0 0 0 rgba(233,217,145,.7),  0 0 0 0 rgba(255,100,74,.7);}

  	40%
  	{box-shadow: 0 0 0 80px rgba(233,217,145,.0),  0 0 0 0 rgba(255,100,74,.7);}

  	80%
  	{box-shadow: 0 0 0 80px rgba(233,217,145,.0),  0 0 0 30px rgba(255,100,74,.0);}

  	100%
  	{box-shadow: 0 0 0 0 rgba(233,217,145,.0), 0 0 0 30px rgba(255,100,74,.0);}
  }
`

const IconBlock = styled.div`
  text-align: center;
  color: #393939;
  font-size: 1.3em;
  background-color: white;
  border-radius:3px;
  padding: 20px;
  margin: 40px 0px 0px;
  box-shadow: 0px 2px 3px rgba(0,0,0,0.3);
  position: relative;
  padding: 20px 20px 58px;

  &:hover {
    top: -1px;
    transform: 1s ease;
    filter: brightness(1);
  }

  @media (min-width: 992px) {
    min-height: 300px;
  }

  @media (min-width: 1200px) {
    min-height: 350px;
  }

  img {
    width: 60px;
    height: 60px;
    margin-bottom: 20px;
  }

  span {
    display: block;
    font-weight: 700;
    padding-bottom: 15px;
  }

  p {
    color: #777777;
    font-size: .8em;
  }
`;

const Centered = styled.div`
  width: 100%;
  #mc_embed_signup_scroll {
    position: auto;
    margin: 0 auto;
  }
`;

const HelpLinks = styled.div`
  text-align: center;
  padding: 40px 0;
  opacity: 0.6;

  ul {
    padding: 0;

    li {
      display: inline;
      list-style: none;
      color: white;
      padding: 0 5px;

      a {
        color: white;
      }
    }
  }
`;

const ReadLinks = styled.div`
  text-align: center;

  ul {
    padding: 0 0 30px;

    li {
      display: block;
      list-style: none;
      color: white;
      padding: 0 5px;

      a {
        color: white;
      }
    }
  }
`;

const Pad50 = styled.div`
  width: 100%;
  height: 50px;
`;

const MarketingPage = () => (
  <Wrapper>

    <SVGWrapper dangerouslySetInnerHTML={{__html: backgroundSVG}} />

    <Navigation />

    <Grid>
      <Row>
        <Col md={12} lg={6}>
          <H2>Bid on player cards. <br/>Collect your team. <br/>Win ether.</H2>
          <Caption>Collect an entire World Cup team and win ether. If your team wins the 2018 World Cup, you’ll win an even bigger pot of ether.</Caption>
        </Col>
        <Col md={12} lg={6}>
          <CardFan>
            <img src="/images/card-2.jpg" alt="Luis Patrico"/>
            <img src="/images/card-3.jpg" alt="Julian Brandt"/>
            <img src="/images/card-1.jpg" alt="Lionel Messi"/>
          </CardFan>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={8} mdOffset={2} lg={8} lgOffset={2}>
        <H3>Learn more about WWWorld Cup</H3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Centered>
            <MailChimp dangerouslySetInnerHTML={{__html: mailChimpSignupForm}} />
            <SmCaption>We’ll only use your email to send you updates about WWWorld Cup.</SmCaption>
          </Centered>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={8} mdOffset={2} lg={8} lgOffset={2}>
          <Pad50 />
          <H4>WWWorld Cup is an Ethereum trading card game for soccer fans.</H4>
          <P>Every day through July 15th, 2018, unique player cards — built on blockchain technology — are released. Bid on new player cards to collect your favorite team. Trade or sell player cards on OpenSea. Build a complete team and win ether.</P>
        </Col>
      </Row>
      <Pad50 />
      <Pad50 />
      <Row>
        <Col sm={12} md={8} mdOffset={2}>
          <PrizeBlock>
            <img src="/images/icon-trophy.svg" alt="Trophy" />
          </PrizeBlock>
          <PrizeH4>FINAL: France wins!</PrizeH4>
          <P>Thank you to everyone who participated in WWWorld Cup this year. Enjoy your collectables, and sign up for email below to hear about our next crypto game experiment!</P>
        </Col>
      </Row>
        <Pad50 />
      <Row>
        <Col sm={12} md={6} mdOffset={3} lg={6} lgOffset={3}>
          <Pad50 />
          <H4>Play to win, even if you’re new to Ethereum</H4>
        </Col>
      </Row>

      <Row>
        <Col sm={12} md={6} lg={3}>
          <IconBlock>
            <img src="/images/icon-wallet.svg" alt="ETH Wallet" />
            <span>Download & install MetaMask</span>
            <p>Set up your wallet and send ether to that address to fund your account.</p>
            <Cta href="https://metamask.io/" target="_blank">Get Metamask</Cta>
          </IconBlock>
        </Col>
        <Col sm={12} md={6} lg={3}>
          <IconBlock>
            <img src="/images/icon-auction.svg" alt="Auction" />
            <span>Bid on player cards</span>
            <p>Every day, new player cards will be released. Bid on player cards to collect your team.</p>
            <Cta href="https://wwworldcup.com/new-cards" target="_blank">See new cards</Cta>
          </IconBlock>
        </Col>
        <Col sm={12} md={6} lg={3}>
          <IconBlock>
            <img src="/images/icon-collect.svg" alt="Collect Cards" />
            <span>Build a complete team</span>
            <p>Cards are limited. There’s only one of each legendary player card, two of each rare player card, and three of each common player card. Only one complete set per team can be collected.</p>
            <Cta href="https://wwworldcup.com/your-cards" target="_blank">Track your cards</Cta>
          </IconBlock>
        </Col>
        <Col sm={12} md={6} lg={3}>
          <IconBlock>
            <img src="/images/icon-trade.svg" alt="Trade Cards" />
            <span>Buy sell & trade on OpenSea</span>
            <p>Each card is unique and cannot be cloned, copied, or forged. As your cards increase in value, trade, sell, or keep them.</p>
            <Cta href="https://opensea.io/assets/wwworldcup" target="_blank">Go to OpenSea</Cta>
          </IconBlock>
        </Col>
      </Row>

      <Row>
        <Col>
          <Pad50 />
          <H4>Learn more</H4>
          <ReadLinks>
            <ul>
              <li>
                <a href="https://www.coindesk.com/information/what-is-ethereum/" target="_blank" rel="noopener noreferrer">How Ethereum works</a>
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=2YeyTF5lalE" target="_blank" rel="noopener noreferrer">How to install and use MetaMask</a>
              </li>
              <li>
                <a href="https://medium.com/@wwworldcup/how-to-win-wwworld-cup-a92442f85394" target="_blank" rel="noopener noreferrer">How to win WWWorld Cup</a>
              </li>
              <li>
                <a href="https://medium.com/@wwworldcup/what-world-cup-fans-need-to-know-about-crypto-collectibles-31e09725d70d" target="_blank" rel="noopener noreferrer">About crypto collectibles for soccer fans</a>
              </li>
            </ul>
          </ReadLinks>
        </Col>
      </Row>

      <Row>
        <Col>
          <Centered>
            <MailChimp dangerouslySetInnerHTML={{__html: mailChimpSignupForm}} />
          </Centered>
        </Col>
      </Row>

      <Row>
        <Col>
          <HelpLinks>
            <ul>
              <li>
                <a href="https://twitter.com/wwworldcup" target="_blank" rel="noopener noreferrer">Twitter</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://www.facebook.com/wwworldcup18/" target="_blank" rel="noopener noreferrer">Facebook</a>
              </li>
              <li>|</li>
              <li>
                <a href="https://medium.com/@wwworldcup" target="_blank" rel="noopener noreferrer">Medium</a>
              </li>
            </ul>
          </HelpLinks>
        </Col>
      </Row>

    </Grid>
    <FooterUI />

  </Wrapper>
);

export default MarketingPage;



// WEBPACK FOOTER //
// ./src/pages/MarketingPage.js